import { useCallback } from "react";
import { PaymentsApi, useAPIAction } from "melco-shared-logic";
import { ProcessPaymentFormValueInterface } from "../../components/reports/payments/ProcessPaymentForm";



export const useProcessPayment = () => {
  const [processPayment] = useAPIAction(
    PaymentsApi,
    async (api, processPaymentDetails: ProcessPaymentFormValueInterface) => {

      const data = await api.paymentsManualProcess({
        id: processPaymentDetails.id ?? "",
        controlcenterMelcoModelsProcessPayment: {
          comments: processPaymentDetails.comments,
          transaction_id: processPaymentDetails.transaction_id
          , payment_status: processPaymentDetails.submitPaymentStatus,
          payment_amount: processPaymentDetails.payment_amount
        },
      });

      return {
        successMessages: processPaymentDetails.submitPaymentStatus === 2 ? [{ message: "default" }] : [{ message: "archive_payment" }],
        data,
      };
    },
    {
      translationPrefix: "payments.actions.process",
    },

  );

  return useCallback(
    async (forwardLinkDetails: ProcessPaymentFormValueInterface) => {
      try {
        await processPayment(forwardLinkDetails);
      } catch (e) {
        return { success: false };
      }

      return { success: true };
    },
    [processPayment]
  );
};
